// Tour.js

import React from 'react';
import Joyride from 'react-joyride';

const Tour = ({ steps, run, continuous, styles, ...props }) => {
  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={continuous}
      styles={{
        options: {
          primaryColor: "#0e7490",
          textColor: "#1f2937",
          arrowColor: "#fff",
          overlayColor: "rgba(15, 23, 42, 0.55)",
          zIndex: 10000,
        },
        spotlight: {
          borderRadius: 16,
          boxShadow:
            "0 0 0 4px rgba(14, 116, 144, 0.45), 0 0 24px rgba(14, 116, 144, 0.35)",
        },
        tooltip: {
          borderRadius: 14,
        },
        tooltipContent: {
          textAlign: "left",
        },
        buttonNext: {
          backgroundColor: "#0e7490",
          borderRadius: 999,
          padding: "8px 18px",
          fontWeight: 600,
        },
        buttonBack: {
          color: "#0e7490",
          fontWeight: 600,
        },
        ...styles,
      }}
      {...props}
    />
  );
};

export default Tour;
